jQuery(document).ready(function() {
    // Singende Form Submit
    jQuery('.webform-submission-singende-dose-singende-dose-form').on('submit', function(e) {
        const fileInput = jQuery('.webform-submission-singende-dose-singende-dose-form input.form-file[type="file"]');
        const fileUpload = jQuery('.webform-submission-singende-dose-singende-dose-form .singing-cans-file-upload');

        if (fileInput.length === 0 || fileInput[0].files.length === 0) {
            if(jQuery('[data-drupal-selector="edit-kassenbon-hochladen-remove-button"]').length === 0) {
                e.preventDefault();
    
                fileUpload.addClass('invalid');
    
                fileUpload.append('<div class="messages messages--error file-upload-js-error" aria-live="polite"></div>');
    
                jQuery('.singing-cans-file-upload .messages.messages--error.file-upload-js-error').html('<span class="no-file-input">Sie müssen die Quittung hochladen</span>');
            }
        } else {
            fileUpload.removeClass('invalid');

            fileUpload.remove('.messages.messages--error.file-upload-js-error');
        }
    })
    
    // Normale Form Submit

    jQuery('.webform-submission-singende-dose-normale-dose-form').on('submit', function(e) {
        const fileInput = jQuery('.webform-submission-singende-dose-normale-dose-form input.form-file[type="file"]');
        const fileUpload = jQuery('.webform-submission-singende-dose-normale-dose-form .singing-cans-file-upload');

        if (fileInput.length === 0 || fileInput[0].files.length === 0) {
            if(jQuery('[data-drupal-selector="edit-kassenbon-hochladen-remove-button"]').length === 0) {
                e.preventDefault();
    
                fileUpload.addClass('invalid');
    
                fileUpload.append('<div class="messages messages--error file-upload-js-error" aria-live="polite"></div>');
    
                jQuery('.singing-cans-file-upload .messages.messages--error.file-upload-js-error').html('<span class="no-file-input">Sie müssen die Quittung hochladen</span>');
            }
        } else {
            fileUpload.removeClass('invalid');

            fileUpload.remove('.messages.messages--error.file-upload-js-error');
        }
    })
});